module.exports = __webpack_public_path__ + "static/media/welcome-img.271d5422.png";